import React from 'react';

import { Form, Modal } from 'antd';
import { FormInstance } from 'antd/lib';
import styled from 'styled-components';

import CreateEditActionPlansModalFooter from './CreateEditActionPlansModalFooter';
import CreateEditActionPlansModalHeader from './CreateEditActionPlansModalHeader';
import CreateEditActionPlansModalMainContent from './CreateEditActionPlansModalMainContent';
import { ActionPlanFormValues, OwnerOption, SelectOption } from './CreateEditActionPlansModalTypes';

const StyledModal = styled(Modal)`
  &&& {
    top: 16px;
    padding-bottom: 16px;

    .ant-modal-close {
      top: 24px;
      right: 26px;
      color: var(--gray-dark);
    }

    .ant-modal-content {
      padding: 0;
      line-height: 1;
      border-radius: 0;
      user-select: none;
      overflow: hidden;
    }

    .ant-modal-body {
      display: flex;
      flex-direction: column;
      padding: 0;
      line-height: normal;
      min-height: 674px;
      height: min(850px, calc(100vh - 32px));
    }
  }
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  .ant-form {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
  }
`;

export type { ActionPlanFormValues } from './CreateEditActionPlansModalTypes';

type Props = {
  categoryOptions: SelectOption[];
  itemTypeOptions: SelectOption[];
  open: boolean;
  isEditing: boolean;
  isSaving?: boolean;
  form: FormInstance<ActionPlanFormValues>;
  ownerOptions: OwnerOption[];
  onCancel: () => void;
  onDelete?: () => void;
  onSubmit: () => void | Promise<void>;
};

const CreateEditActionPlanModal = ({
  categoryOptions,
  itemTypeOptions,
  open,
  isEditing,
  isSaving = false,
  form,
  ownerOptions,
  onCancel,
  onDelete,
  onSubmit,
}: Props) => {
  const handleCancel = () => {
    if (isSaving) {
      return;
    }

    onCancel();
  };

  return (
    <StyledModal open={open} onCancel={handleCancel} footer={null} destroyOnClose width={1200}>
      <CreateEditActionPlansModalHeader isEditing={isEditing} />
      <BodyContainer>
        <Form form={form} layout="vertical">
          <CreateEditActionPlansModalMainContent
            categoryOptions={categoryOptions}
            itemTypeOptions={itemTypeOptions}
            ownerOptions={ownerOptions}
          />
        </Form>
      </BodyContainer>
      <CreateEditActionPlansModalFooter
        isEditing={isEditing}
        isSaving={isSaving}
        onCancel={handleCancel}
        onDelete={onDelete}
        onSubmit={onSubmit}
      />
    </StyledModal>
  );
};

export default CreateEditActionPlanModal;
